export const MENUWORKSPACE = "MENUWORKSPACE";
export const WORKSPACELIST = "WORKSPACELIST";
export const WORKSPACEID = "WORKSPACEID";

export function pushMenuWorkspace(values) {
  return {
    type: MENUWORKSPACE,
    payload: values
  };
}

export function pushWorkspaceList(values) {
  return {
    type: WORKSPACELIST,
    payload: values
  };
}

export function pushWorkspaceID(values) {
  return {
    type: WORKSPACEID,
    payload: values
  };
}
